import { ACTIONS } from '../actions/admin-company';

const table = [
    {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    },
    {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    }, {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    }, {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    }, {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    }, {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    }, {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    }, {
        item: [
            {
                text: 'なまえ'
            },
            {
                text: 'loginid'
            },
            {
                action: ['設定変更', '削除']
            }
        ]
    },
];

const header = ['名前', 'ログインID', ''];

export default (state = { table, header }, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_COMPANY_SUCCESS:
        case ACTIONS.POST_DATA_COMPANY_SUCCESS:
        case ACTIONS.UPDATE_DATA_COMPANY_SUCCESS:
        case ACTIONS.REMOVE_DATA_COMPANY_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
                message: action.data.message
            };
        case ACTIONS.GET_DATA_COMPANY_ERROR:
        case ACTIONS.POST_DATA_COMPANY_ERROR:
        case ACTIONS.UPDATE_DATA_COMPANY_ERROR:
        case ACTIONS.REMOVE_DATA_COMPANY_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
                message: action.data.message
            }
        case ACTIONS.GET_DATA_CLIENT_SUCCESS:
        case ACTIONS.ADD_DATA_CLIENT_SUCCESS:
        case ACTIONS.UPDATE_DATA_CLIENT_SUCCESS:
        case ACTIONS.DELETE_DATA_CLIENT_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
                message: action.data.message,
                meta: action.data.meta,
            };
        case ACTIONS.GET_DATA_CLIENT_ERROR:
        case ACTIONS.ADD_DATA_CLIENT_ERROR:
        case ACTIONS.UPDATE_DATA_CLIENT_ERROR:
        case ACTIONS.DELETE_DATA_CLIENT_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
                message: action.data.message,
            }
        default:
            return state;
    }
};